<button (click)="topFunction()" class="btn btn-danger btn-icon" id="back-to-top">
  <i class="ri-arrow-up-line"></i>
</button>

<!--preloader-->
<div id="preloader">
  <div id="status">
    <div class="spinner-border text-primary avatar-sm" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
</div>

<!-- Theme customizer button removed for production -->

<!-- Theme Settings -->
<ng-template #filtetcontent let-offcanvas>
  <div class="d-flex align-items-center bg-primary bg-gradient p-3 offcanvas-header">
    <h5 class="m-0 me-2 text-white">Theme Customizer</h5>
    <button type="button" class="btn-close btn-close-white ms-auto " data-bs-dismiss="offcanvas" aria-label="Close" (click)="offcanvas.dismiss('Cross click')"></button>
  </div>
  <div class="offcanvas-body p-0 right-sidebar">
    <ngx-simplebar class="h-100">
      <div class="p-4">
        <h6 class="mb-0 fw-semibold text-uppercase">Layout</h6>
        <p class="text-muted">Choose your layout</p>

        <div class="row">
          <div class="col-4">
            <div class="form-check card-radio">
              <input id="customizer-layout01" name="data-layout" type="radio" value="vertical" class="form-check-input" (click)="changeLayout('vertical')">
              <label class="form-check-label p-0 avatar-md w-100 material-shadow" for="customizer-layout01">
                <span class="d-flex gap-1 h-100">
                  <span class="flex-shrink-0">
                    <span class="bg-light d-flex h-100 flex-column gap-1 p-1">
                      <span class="d-block p-1 px-2 bg-primary-subtle rounded mb-2"></span>
                      <span class="d-block p-1 px-2 pb-0 bg-primary-subtle"></span>
                      <span class="d-block p-1 px-2 pb-0 bg-primary-subtle"></span>
                      <span class="d-block p-1 px-2 pb-0 bg-primary-subtle"></span>
                    </span>
                  </span>
                  <span class="flex-grow-1">
                    <span class="d-flex h-100 flex-column">
                      <span class="bg-light d-block p-1"></span>
                      <span class="bg-light d-block p-1 mt-auto"></span>
                    </span>
                  </span>
                </span>
              </label>
            </div>
            <h5 class="fs-13 text-center mt-2">Vertical</h5>
          </div>
          <div class="col-4">
            <div class="form-check card-radio">
              <input id="customizer-layout02" name="data-layout" type="radio" value="horizontal" class="form-check-input" (click)="changeLayout('horizontal')">
              <label class="form-check-label p-0 avatar-md w-100 material-shadow" for="customizer-layout02">
                <span class="d-flex h-100 flex-column gap-1">
                  <span class="bg-light d-flex p-1 gap-1 align-items-center">
                    <span class="d-block p-1 bg-primary-subtle rounded me-1"></span>
                    <span class="d-block p-1 pb-0 px-2 bg-primary-subtle ms-auto"></span>
                    <span class="d-block p-1 pb-0 px-2 bg-primary-subtle"></span>
                  </span>
                  <span class="bg-light d-block p-1"></span>
                  <span class="bg-light d-block p-1 mt-auto"></span>
                </span>
              </label>
            </div>
            <h5 class="fs-13 text-center mt-2">Horizontal</h5>
          </div>
          <div class="col-4">
            <div class="form-check card-radio">
              <input id="customizer-layout03" name="data-layout" type="radio" value="twocolumn" class="form-check-input" (click)="changeLayout('twocolumn')">
              <label class="form-check-label p-0 avatar-md w-100 material-shadow" for="customizer-layout03">
                <span class="d-flex gap-1 h-100">
                  <span class="flex-shrink-0">
                    <span class="bg-light d-flex h-100 flex-column gap-1">
                      <span class="d-block p-1 bg-primary-subtle mb-2"></span>
                      <span class="d-block p-1 pb-0 bg-primary-subtle"></span>
                      <span class="d-block p-1 pb-0 bg-primary-subtle"></span>
                      <span class="d-block p-1 pb-0 bg-primary-subtle"></span>
                    </span>
                  </span>
                  <span class="flex-shrink-0">
                    <span class="bg-light d-flex h-100 flex-column gap-1 p-1">
                      <span class="d-block p-1 px-2 pb-0 bg-primary-subtle"></span>
                      <span class="d-block p-1 px-2 pb-0 bg-primary-subtle"></span>
                      <span class="d-block p-1 px-2 pb-0 bg-primary-subtle"></span>
                      <span class="d-block p-1 px-2 pb-0 bg-primary-subtle"></span>
                    </span>
                  </span>
                  <span class="flex-grow-1">
                    <span class="d-flex h-100 flex-column">
                      <span class="bg-light d-block p-1"></span>
                      <span class="bg-light d-block p-1 mt-auto"></span>
                    </span>
                  </span>
                </span>
              </label>
            </div>
            <h5 class="fs-13 text-center mt-2">Two Column</h5>
          </div>
          <!-- end col -->

          <div class="col-4">
            <div class="form-check card-radio">
              <input id="customizer-layout04" name="data-layout" type="radio" value="semibox" class="form-check-input" (click)="changeLayout('semibox')">
              <label class="form-check-label p-0 avatar-md w-100 material-shadow" for="customizer-layout04">
                <span class="d-flex gap-1 h-100">
                  <span class="flex-shrink-0 p-1">
                    <span class="bg-light d-flex h-100 flex-column gap-1 p-1">
                      <span class="d-block p-1 px-2 bg-primary-subtle rounded mb-2"></span>
                      <span class="d-block p-1 px-2 pb-0 bg-primary-subtle"></span>
                      <span class="d-block p-1 px-2 pb-0 bg-primary-subtle"></span>
                      <span class="d-block p-1 px-2 pb-0 bg-primary-subtle"></span>
                    </span>
                  </span>
                  <span class="flex-grow-1">
                    <span class="d-flex h-100 flex-column pt-1 pe-2">
                      <span class="bg-light d-block p-1"></span>
                      <span class="bg-light d-block p-1 mt-auto"></span>
                    </span>
                  </span>
                </span>
              </label>
            </div>
            <h5 class="fs-13 text-center mt-2">Semi Box</h5>
          </div>
          <!-- end col -->
        </div>

        <div class="form-check form-switch form-switch-md mb-3 mt-4">
          <input type="checkbox" class="form-check-input" id="sidebarUserProfile" (change)="showSidebarProgile($event)">
          <label class="form-check-label sidebar-profile" for="sidebarUserProfile">Sidebar User Profile Avatar</label>
        </div>

        <h6 class="mt-4 mb-0 fw-semibold text-uppercase">Theme</h6>
        <p class="text-muted">Choose your suitable Theme.</p>

        <div class="row">
          <div class="col-6">
            <div class="form-check card-radio">
              <input id="customizer-theme01" name="data-theme" type="radio" value="default" class="form-check-input" (change)="changelayoutTheme('default')" [checked]="theme === 'default'">
              <label class="form-check-label p-0" for="customizer-theme01">
                <img src="https://themesbrand.com/velzon/assets/images/demo/default.png" alt="" class="img-fluid">
              </label>
            </div>
            <h5 class="fs-13 text-center fw-medium mt-2">Default</h5>
          </div>
          <div class="col-6">
            <div class="form-check card-radio">
              <input id="customizer-theme02" name="data-theme" type="radio" value="saas" class="form-check-input" (change)="changelayoutTheme('saas')" [checked]="theme === 'saas'">
              <label class="form-check-label p-0" for="customizer-theme02">
                <img src="https://themesbrand.com/velzon/assets/images/demo//saas.png" alt="" class="img-fluid">
              </label>
            </div>
            <h5 class="fs-13 text-center fw-medium mt-2">Sass</h5>
          </div>
          <div class="col-6">
            <div class="form-check card-radio">
              <input id="customizer-theme03" name="data-theme" type="radio" value="corporate" class="form-check-input" (change)="changelayoutTheme('corporate')" [checked]="theme === 'corporate'">
              <label class="form-check-label p-0" for="customizer-theme03">
                <img src="https://themesbrand.com/velzon/assets/images/demo//corporate.png" alt="" class="img-fluid">
              </label>
            </div>
            <h5 class="fs-13 text-center fw-medium mt-2">Corporate</h5>
          </div>
          <div class="col-6">
            <div class="form-check card-radio">
              <input id="customizer-theme04" name="data-theme" type="radio" value="galaxy" class="form-check-input" (change)="changelayoutTheme('galaxy')" [checked]="theme === 'galaxy'">
              <label class="form-check-label p-0" for="customizer-theme04">
                <img src="https://themesbrand.com/velzon/assets/images/demo//galaxy.png" alt="" class="img-fluid">
              </label>
            </div>
            <h5 class="fs-13 text-center fw-medium mt-2">Galaxy</h5>
          </div>
          <div class="col-6">
            <div class="form-check card-radio">
              <input id="customizer-theme05" name="data-theme" type="radio" value="material" class="form-check-input" (change)="changelayoutTheme('material')" [checked]="theme === 'material'">
              <label class="form-check-label p-0" for="customizer-theme05">
                <img src="https://themesbrand.com/velzon/assets/images/demo//material.png" alt="" class="img-fluid">
              </label>
            </div>
            <h5 class="fs-13 text-center fw-medium mt-2">Material</h5>
          </div>
          <div class="col-6">
            <div class="form-check card-radio">
              <input id="customizer-theme06" name="data-theme" type="radio" value="creative" class="form-check-input" (change)="changelayoutTheme('creative')" [checked]="theme === 'creative'">
              <label class="form-check-label p-0" for="customizer-theme06">
                <img src="https://themesbrand.com/velzon/assets/images/demo/creative.png" alt="" class="img-fluid">
              </label>
            </div>
            <h5 class="fs-13 text-center fw-medium mt-2">Creative</h5>
          </div>
          <div class="col-6">
            <div class="form-check card-radio">
              <input id="customizer-theme07" name="data-theme" type="radio" value="minimal" class="form-check-input" (change)="changelayoutTheme('minimal')" [checked]="theme === 'minimal'">
              <label class="form-check-label p-0" for="customizer-theme07">
                <img src="https://themesbrand.com/velzon/assets/images/demo/minimal.png" alt="" class="img-fluid">
              </label>
            </div>
            <h5 class="fs-13 text-center fw-medium mt-2">Minimal</h5>
          </div>
          <div class="col-6">
            <div class="form-check card-radio">
              <input id="customizer-theme08" name="data-theme" type="radio" value="modern" class="form-check-input" (change)="changelayoutTheme('modern')" [checked]="theme === 'modern'">
              <label class="form-check-label p-0" for="customizer-theme08">
                <img src="https://themesbrand.com/velzon/assets/images/demo/modern.png" alt="" class="img-fluid">
              </label>
            </div>
            <h5 class="fs-13 text-center fw-medium mt-2">Modern</h5>
          </div>
          <!-- end col -->
          <div class="col-6">
            <div class="form-check card-radio">
              <input id="customizer-theme09" name="data-theme" type="radio" value="interactive" class="form-check-input" (change)="changelayoutTheme('interactive')" [checked]="theme === 'interactive'">
              <label class="form-check-label p-0" for="customizer-theme09">
                <img src="https://themesbrand.com/velzon/assets/images/demo/interactive.png" alt="" class="img-fluid">
              </label>
            </div>
            <h5 class="fs-13 text-center fw-medium mt-2">Interactive</h5>
          </div><!-- end col -->

          <div class="col-6">
            <div class="form-check card-radio">
              <input id="customizer-theme10" name="data-theme" type="radio" value="classic" class="form-check-input" (change)="changelayoutTheme('classic')" [checked]="theme === 'classic'">
              <label class="form-check-label p-0" for="customizer-theme10">
                <img src="https://themesbrand.com/velzon/assets/images/demo/classic.png" alt="" class="img-fluid">
              </label>
            </div>
            <h5 class="fs-13 text-center fw-medium mt-2">Classic</h5>
          </div><!-- end col -->

          <div class="col-6">
            <div class="form-check card-radio">
              <input id="customizer-theme11" name="data-theme" type="radio" value="vintage" class="form-check-input" (change)="changelayoutTheme('vintage')" [checked]="theme === 'vintage'">
              <label class="form-check-label p-0" for="customizer-theme11">
                <img src="https://themesbrand.com/velzon/assets/images/demo/vintage.png" alt="" class="img-fluid">
              </label>
            </div>
            <h5 class="fs-13 text-center fw-medium mt-2">Vintage</h5>
          </div><!-- end col -->
        </div>

        <h6 class="mt-4 mb-0 fw-semibold text-uppercase">Color Scheme</h6>
        <p class="text-muted">Choose Light or Dark Scheme.</p>
        <div class="colorscheme-cardradio">
          <div class="row">
            <div class="col-4">
              <div class="form-check card-radio">
                <input class="form-check-input" type="radio" name="data-layout-mode" id="layout-mode-light" value="light" [checked]="mode === 'light'" (change)="changeLayoutMode('light')">
                <label class="form-check-label p-0 avatar-md w-100 material-shadow" for="layout-mode-light">
                  <span class="d-flex gap-1 h-100">
                    <span class="flex-shrink-0">
                      <span class="bg-light d-flex h-100 flex-column gap-1 p-1">
                        <span class="d-block p-1 px-2 bg-primary-subtle rounded mb-2"></span>
                        <span class="d-block p-1 px-2 pb-0 bg-primary-subtle"></span>
                        <span class="d-block p-1 px-2 pb-0 bg-primary-subtle"></span>
                        <span class="d-block p-1 px-2 pb-0 bg-primary-subtle"></span>
                      </span>
                    </span>
                    <span class="flex-grow-1">
                      <span class="d-flex h-100 flex-column">
                        <span class="bg-light d-block p-1"></span>
                        <span class="bg-light d-block p-1 mt-auto"></span>
                      </span>
                    </span>
                  </span>
                </label>
              </div>
              <h5 class="fs-13 text-center mt-2">Light</h5>
            </div>

            <div class="col-4">
              <div class="form-check card-radio dark">
                <input class="form-check-input" type="radio" name="data-layout-mode" id="layout-mode-dark" value="dark" [checked]="mode === 'dark'" (change)="changeLayoutMode('dark')">
                <label class="form-check-label p-0 avatar-md w-100 bg-dark material-shadow" for="layout-mode-dark">
                  <span class="d-flex gap-1 h-100">
                    <span class="flex-shrink-0">
                      <span class="bg-light-subtle d-flex h-100 flex-column gap-1 p-1">
                        <span class="d-block p-1 px-2 bg-light-subtle rounded mb-2"></span>
                        <span class="d-block p-1 px-2 pb-0 bg-light-subtle"></span>
                        <span class="d-block p-1 px-2 pb-0 bg-light-subtle"></span>
                        <span class="d-block p-1 px-2 pb-0 bg-light-subtle"></span>
                      </span>
                    </span>
                    <span class="flex-grow-1">
                      <span class="d-flex h-100 flex-column">
                        <span class="bg-light-subtle d-block p-1"></span>
                        <span class="bg-light-subtle d-block p-1 mt-auto"></span>
                      </span>
                    </span>
                  </span>
                </label>
              </div>
              <h5 class="fs-13 text-center mt-2">Dark</h5>
            </div>
          </div>
        </div>

        @if (attribute === 'semibox') {
          <div id="sidebar-visibility">
            <h6 class="mt-4 mb-0 fw-semibold text-uppercase">Sidebar Visibility</h6>
            <p class="text-muted">Choose show or Hidden sidebar.</p>
            <div class="row">
              <div class="col-4">
                <div class="form-check card-radio">
                  <input class="form-check-input" type="radio" name="data-sidebar-visibility" id="sidebar-visibility-show" value="show" (change)="changeVisibility('show')" [checked]="sidebarVisibility === 'show'">
                  <label class="form-check-label p-0 avatar-md w-100 material-shadow" for="sidebar-visibility-show">
                    <span class="d-flex gap-1 h-100">
                      <span class="flex-shrink-0 p-1">
                        <span class="bg-light d-flex h-100 flex-column gap-1 p-1">
                          <span class="d-block p-1 px-2 bg-primary-subtle rounded mb-2"></span>
                          <span class="d-block p-1 px-2 pb-0 bg-primary-subtle"></span>
                          <span class="d-block p-1 px-2 pb-0 bg-primary-subtle"></span>
                          <span class="d-block p-1 px-2 pb-0 bg-primary-subtle"></span>
                        </span>
                      </span>
                      <span class="flex-grow-1">
                        <span class="d-flex h-100 flex-column pt-1 pe-2">
                          <span class="bg-light d-block p-1"></span>
                          <span class="bg-light d-block p-1 mt-auto"></span>
                        </span>
                      </span>
                    </span>
                  </label>
                </div>
                <h5 class="fs-13 text-center mt-2">Show</h5>
              </div>
              <div class="col-4">
                <div class="form-check card-radio">
                  <input class="form-check-input" type="radio" name="data-sidebar-visibility" id="sidebar-visibility-hidden" value="hidden" (change)="changeVisibility('hidden')" [checked]="sidebarVisibility === 'hidden'">
                  <label class="form-check-label p-0 avatar-md w-100 px-2 material-shadow" for="sidebar-visibility-hidden">
                    <span class="d-flex gap-1 h-100">
                      <span class="flex-grow-1">
                        <span class="d-flex h-100 flex-column pt-1 px-2">
                          <span class="bg-light d-block p-1"></span>
                          <span class="bg-light d-block p-1 mt-auto"></span>
                        </span>
                      </span>
                    </span>
                  </label>
                </div>
                <h5 class="fs-13 text-center mt-2">Hidden</h5>
              </div>
            </div>
          </div>
        }

        @if (attribute === 'vertical' || attribute === 'horizontal') {
          <div id="layout-width">
            <h6 class="mt-4 mb-0 fw-semibold text-uppercase">Layout Width</h6>
            <p class="text-muted">Choose Fluid or Boxed layout.</p>
            <div class="row">
              <div class="col-4">
                <div class="form-check card-radio">
                  <input class="form-check-input" type="radio" name="data-layout-width" id="layout-width-fluid" value="fluid" [checked]="width === 'fluid'" (change)="changeWidth('fluid','lg')">
                  <label class="form-check-label p-0 avatar-md w-100 material-shadow" for="layout-width-fluid">
                    <span class="d-flex gap-1 h-100">
                      <span class="flex-shrink-0">
                        <span class="bg-light d-flex h-100 flex-column gap-1 p-1">
                          <span class="d-block p-1 px-2 bg-primary-subtle rounded mb-2"></span>
                          <span class="d-block p-1 px-2 pb-0 bg-primary-subtle"></span>
                          <span class="d-block p-1 px-2 pb-0 bg-primary-subtle"></span>
                          <span class="d-block p-1 px-2 pb-0 bg-primary-subtle"></span>
                        </span>
                      </span>
                      <span class="flex-grow-1">
                        <span class="d-flex h-100 flex-column">
                          <span class="bg-light d-block p-1"></span>
                          <span class="bg-light d-block p-1 mt-auto"></span>
                        </span>
                      </span>
                    </span>
                  </label>
                </div>
                <h5 class="fs-13 text-center mt-2">Fluid</h5>
              </div>
              <div class="col-4">
                <div class="form-check card-radio">
                  <input class="form-check-input" type="radio" name="data-layout-width" id="layout-width-boxed" value="boxed" [checked]="width === 'boxed'" (change)="changeWidth('boxed','sm-hover')">
                  <label class="form-check-label p-0 avatar-md w-100 px-2 material-shadow" for="layout-width-boxed">
                    <span class="d-flex gap-1 h-100 border-start border-end">
                      <span class="flex-shrink-0">
                        <span class="bg-light d-flex h-100 flex-column gap-1 p-1">
                          <span class="d-block p-1 px-2 bg-primary-subtle rounded mb-2"></span>
                          <span class="d-block p-1 px-2 pb-0 bg-primary-subtle"></span>
                          <span class="d-block p-1 px-2 pb-0 bg-primary-subtle"></span>
                          <span class="d-block p-1 px-2 pb-0 bg-primary-subtle"></span>
                        </span>
                      </span>
                      <span class="flex-grow-1">
                        <span class="d-flex h-100 flex-column">
                          <span class="bg-light d-block p-1"></span>
                          <span class="bg-light d-block p-1 mt-auto"></span>
                        </span>
                      </span>
                    </span>
                  </label>
                </div>
                <h5 class="fs-13 text-center mt-2">Boxed</h5>
              </div>
            </div>
          </div>
        }

        @if (attribute === 'vertical' || attribute === 'horizontal' || attribute === 'semibox') {
          <div id="layout-position">
            <h6 class="mt-4 mb-0 fw-semibold text-uppercase">Layout Position</h6>
            <p class="text-muted">Choose Fixed or Scrollable Layout Position.</p>
            <div class="btn-group radio" role="group">
              <input type="radio" class="btn-check" name="data-layout-position" id="layout-position-fixed" value="fixed" [checked]="position === 'fixed'" (change)="changePosition('fixed')">
              <label class="btn btn-light w-sm" for="layout-position-fixed">Fixed</label>
              <input type="radio" class="btn-check" name="data-layout-position" id="layout-position-scrollable" value="scrollable" [checked]="position === 'scrollable'" (change)="changePosition('scrollable')">
              <label class="btn btn-light w-sm ms-0" for="layout-position-scrollable">Scrollable</label>
            </div>
          </div>
        }

        <h6 class="mt-4 mb-0 fw-semibold text-uppercase">Topbar Color</h6>
        <p class="text-muted">Choose Light or Dark Topbar Color.</p>

        <div class="row">
          <div class="col-4">
            <div class="form-check card-radio">
              <input class="form-check-input" type="radio" name="data-topbar" id="topbar-color-light" value="light" [checked]="topbar === 'light'" (change)="changeTopColor('light')">
              <label class="form-check-label p-0 avatar-md w-100 material-shadow" for="topbar-color-light">
                <span class="d-flex gap-1 h-100">
                  <span class="flex-shrink-0">
                    <span class="bg-light d-flex h-100 flex-column gap-1 p-1">
                      <span class="d-block p-1 px-2 bg-primary-subtle rounded mb-2"></span>
                      <span class="d-block p-1 px-2 pb-0 bg-primary-subtle"></span>
                      <span class="d-block p-1 px-2 pb-0 bg-primary-subtle"></span>
                      <span class="d-block p-1 px-2 pb-0 bg-primary-subtle"></span>
                    </span>
                  </span>
                  <span class="flex-grow-1">
                    <span class="d-flex h-100 flex-column">
                      <span class="bg-light d-block p-1"></span>
                      <span class="bg-light d-block p-1 mt-auto"></span>
                    </span>
                  </span>
                </span>
              </label>
            </div>
            <h5 class="fs-13 text-center mt-2">Light</h5>
          </div>
          <div class="col-4">
            <div class="form-check card-radio">
              <input class="form-check-input" type="radio" name="data-topbar" id="topbar-color-dark" value="dark" [checked]="topbar === 'dark'" (change)="changeTopColor('dark')">
              <label class="form-check-label p-0 avatar-md w-100 material-shadow" for="topbar-color-dark">
                <span class="d-flex gap-1 h-100">
                  <span class="flex-shrink-0">
                    <span class="bg-light d-flex h-100 flex-column gap-1 p-1">
                      <span class="d-block p-1 px-2 bg-primary-subtle rounded mb-2"></span>
                      <span class="d-block p-1 px-2 pb-0 bg-primary-subtle"></span>
                      <span class="d-block p-1 px-2 pb-0 bg-primary-subtle"></span>
                      <span class="d-block p-1 px-2 pb-0 bg-primary-subtle"></span>
                    </span>
                  </span>
                  <span class="flex-grow-1">
                    <span class="d-flex h-100 flex-column">
                      <span class="bg-primary d-block p-1"></span>
                      <span class="bg-light d-block p-1 mt-auto"></span>
                    </span>
                  </span>
                </span>
              </label>
            </div>
            <h5 class="fs-13 text-center mt-2">Dark</h5>
          </div>
        </div>

        @if (attribute === 'vertical' || attribute === 'semibox') {
          <div id="sidebar-size">
            <h6 class="mt-4 mb-0 fw-semibold text-uppercase">Sidebar Size</h6>
            <p class="text-muted">Choose a size of Sidebar.</p>
            <div class="row">
              <div class="col-4">
                <div class="form-check sidebar-setting card-radio">
                  <input class="form-check-input" type="radio" name="data-sidebar-size" id="sidebar-size-default" value="lg" [checked]="size === 'lg'" (change)="changeSidebarSize('lg')">
                  <label class="form-check-label p-0 avatar-md w-100 material-shadow" for="sidebar-size-default">
                    <span class="d-flex gap-1 h-100">
                      <span class="flex-shrink-0">
                        <span class="bg-light d-flex h-100 flex-column gap-1 p-1">
                          <span class="d-block p-1 px-2 bg-primary-subtle rounded mb-2"></span>
                          <span class="d-block p-1 px-2 pb-0 bg-primary-subtle"></span>
                          <span class="d-block p-1 px-2 pb-0 bg-primary-subtle"></span>
                          <span class="d-block p-1 px-2 pb-0 bg-primary-subtle"></span>
                        </span>
                      </span>
                      <span class="flex-grow-1">
                        <span class="d-flex h-100 flex-column">
                          <span class="bg-light d-block p-1"></span>
                          <span class="bg-light d-block p-1 mt-auto"></span>
                        </span>
                      </span>
                    </span>
                  </label>
                </div>
                <h5 class="fs-13 text-center mt-2">Default</h5>
              </div>
              <div class="col-4">
                <div class="form-check sidebar-setting card-radio">
                  <input class="form-check-input" type="radio" name="data-sidebar-size" id="sidebar-size-compact" value="md" [checked]="size === 'md'" (change)="changeSidebarSize('md')">
                  <label class="form-check-label p-0 avatar-md w-100 material-shadow" for="sidebar-size-compact">
                    <span class="d-flex gap-1 h-100">
                      <span class="flex-shrink-0">
                        <span class="bg-light d-flex h-100 flex-column gap-1 p-1">
                          <span class="d-block p-1 bg-primary-subtle rounded mb-2"></span>
                          <span class="d-block p-1 pb-0 bg-primary-subtle"></span>
                          <span class="d-block p-1 pb-0 bg-primary-subtle"></span>
                          <span class="d-block p-1 pb-0 bg-primary-subtle"></span>
                        </span>
                      </span>
                      <span class="flex-grow-1">
                        <span class="d-flex h-100 flex-column">
                          <span class="bg-light d-block p-1"></span>
                          <span class="bg-light d-block p-1 mt-auto"></span>
                        </span>
                      </span>
                    </span>
                  </label>
                </div>
                <h5 class="fs-13 text-center mt-2">Compact</h5>
              </div>
              <div class="col-4">
                <div class="form-check sidebar-setting card-radio">
                  <input class="form-check-input" type="radio" name="data-sidebar-size" id="sidebar-size-small" value="sm" [checked]="size === 'sm'" (change)="changeSidebarSize('sm')">
                  <label class="form-check-label p-0 avatar-md w-100 material-shadow" for="sidebar-size-small">
                    <span class="d-flex gap-1 h-100">
                      <span class="flex-shrink-0">
                        <span class="bg-light d-flex h-100 flex-column gap-1">
                          <span class="d-block p-1 bg-primary-subtle mb-2"></span>
                          <span class="d-block p-1 pb-0 bg-primary-subtle"></span>
                          <span class="d-block p-1 pb-0 bg-primary-subtle"></span>
                          <span class="d-block p-1 pb-0 bg-primary-subtle"></span>
                        </span>
                      </span>
                      <span class="flex-grow-1">
                        <span class="d-flex h-100 flex-column">
                          <span class="bg-light d-block p-1"></span>
                          <span class="bg-light d-block p-1 mt-auto"></span>
                        </span>
                      </span>
                    </span>
                  </label>
                </div>
                <h5 class="fs-13 text-center mt-2">Small (Icon View)</h5>
              </div>
              <div class="col-4">
                <div class="form-check sidebar-setting card-radio">
                  <input class="form-check-input" type="radio" name="data-sidebar-size" id="sidebar-size-small-hover" value="sm-hover" [checked]="size === 'sm-hover'" (change)="changeSidebarSize('sm-hover')">
                  <label class="form-check-label p-0 avatar-md w-100 material-shadow" for="sidebar-size-small-hover">
                    <span class="d-flex gap-1 h-100">
                      <span class="flex-shrink-0">
                        <span class="bg-light d-flex h-100 flex-column gap-1">
                          <span class="d-block p-1 bg-primary-subtle mb-2"></span>
                          <span class="d-block p-1 pb-0 bg-primary-subtle"></span>
                          <span class="d-block p-1 pb-0 bg-primary-subtle"></span>
                          <span class="d-block p-1 pb-0 bg-primary-subtle"></span>
                        </span>
                      </span>
                      <span class="flex-grow-1">
                        <span class="d-flex h-100 flex-column">
                          <span class="bg-light d-block p-1"></span>
                          <span class="bg-light d-block p-1 mt-auto"></span>
                        </span>
                      </span>
                    </span>
                  </label>
                </div>
                <h5 class="fs-13 text-center mt-2">Small Hover View</h5>
              </div>
            </div>
          </div>
        }
        @if (attribute === 'vertical') {
          <div id="sidebar-view">
            <h6 class="mt-4 mb-0 fw-semibold text-uppercase">Sidebar View</h6>
            <p class="text-muted">Choose Default or Detached Sidebar view.</p>
            <div class="row">
              <div class="col-4">
                <div class="form-check sidebar-setting card-radio">
                  <input class="form-check-input" type="radio" name="data-layout-style" id="sidebar-view-default" value="default" [checked]="sidebarView === 'default'" (change)="changeSidebar('default')">
                  <label class="form-check-label p-0 avatar-md w-100 material-shadow" for="sidebar-view-default">
                    <span class="d-flex gap-1 h-100">
                      <span class="flex-shrink-0">
                        <span class="bg-light d-flex h-100 flex-column gap-1 p-1">
                          <span class="d-block p-1 px-2 bg-primary-subtle rounded mb-2"></span>
                          <span class="d-block p-1 px-2 pb-0 bg-primary-subtle"></span>
                          <span class="d-block p-1 px-2 pb-0 bg-primary-subtle"></span>
                          <span class="d-block p-1 px-2 pb-0 bg-primary-subtle"></span>
                        </span>
                      </span>
                      <span class="flex-grow-1">
                        <span class="d-flex h-100 flex-column">
                          <span class="bg-light d-block p-1"></span>
                          <span class="bg-light d-block p-1 mt-auto"></span>
                        </span>
                      </span>
                    </span>
                  </label>
                </div>
                <h5 class="fs-13 text-center mt-2">Default</h5>
              </div>
              <div class="col-4">
                <div class="form-check sidebar-setting card-radio">
                  <input class="form-check-input" type="radio" name="data-layout-style" id="sidebar-view-detached" value="detached" [checked]="sidebarView === 'detached'" (change)="changeSidebar('detached')">
                  <label class="form-check-label p-0 avatar-md w-100 material-shadow" for="sidebar-view-detached">
                    <span class="d-flex h-100 flex-column">
                      <span class="bg-light d-flex p-1 gap-1 align-items-center px-2">
                        <span class="d-block p-1 bg-primary-subtle rounded me-1"></span>
                        <span class="d-block p-1 pb-0 px-2 bg-primary-subtle ms-auto"></span>
                        <span class="d-block p-1 pb-0 px-2 bg-primary-subtle"></span>
                      </span>
                      <span class="d-flex gap-1 h-100 p-1 px-2">
                        <span class="flex-shrink-0">
                          <span class="bg-light d-flex h-100 flex-column gap-1 p-1">
                            <span class="d-block p-1 px-2 pb-0 bg-primary-subtle"></span>
                            <span class="d-block p-1 px-2 pb-0 bg-primary-subtle"></span>
                            <span class="d-block p-1 px-2 pb-0 bg-primary-subtle"></span>
                          </span>
                        </span>
                      </span>
                      <span class="bg-light d-block p-1 mt-auto px-2"></span>
                    </span>
                  </label>
                </div>
                <h5 class="fs-13 text-center mt-2">Detached</h5>
              </div>
            </div>
          </div>
        }
        @if (attribute === 'vertical' || attribute === 'twocolumn' || attribute === 'semibox') {
          <div id="sidebar-color">
            <h6 class="mt-4 mb-0 fw-semibold text-uppercase">Sidebar Color</h6>
            <p class="text-muted">Choose Ligth or Dark Sidebar Color.</p>
            <div class="row">
              <div class="col-4">
                <div class="form-check sidebar-setting card-radio">
                  <input class="form-check-input" type="radio" name="data-sidebar" id="sidebar-color-light" value="light" [checked]="sidebar === 'light'" (change)="changeSidebarColor('light')" (click)="removeActive()">
                  <label class="form-check-label p-0 avatar-md w-100 material-shadow" for="sidebar-color-light">
                    <span class="d-flex gap-1 h-100">
                      <span class="flex-shrink-0">
                        <span class="bg-white border-end d-flex h-100 flex-column gap-1 p-1">
                          <span class="d-block p-1 px-2 bg-primary-subtle rounded mb-2"></span>
                          <span class="d-block p-1 px-2 pb-0 bg-primary-subtle"></span>
                          <span class="d-block p-1 px-2 pb-0 bg-primary-subtle"></span>
                          <span class="d-block p-1 px-2 pb-0 bg-primary-subtle"></span>
                        </span>
                      </span>
                      <span class="flex-grow-1">
                        <span class="d-flex h-100 flex-column">
                          <span class="bg-light d-block p-1"></span>
                          <span class="bg-light d-block p-1 mt-auto"></span>
                        </span>
                      </span>
                    </span>
                  </label>
                </div>
                <h5 class="fs-13 text-center mt-2">Light</h5>
              </div>
              <div class="col-4">
                <div class="form-check sidebar-setting card-radio">
                  <input class="form-check-input" type="radio" name="data-sidebar" id="sidebar-color-dark" value="dark" [checked]="sidebar === 'dark'" (change)="changeSidebarColor('dark')" (click)="removeActive()">
                  <label class="form-check-label p-0 avatar-md w-100 material-shadow" for="sidebar-color-dark">
                    <span class="d-flex gap-1 h-100">
                      <span class="flex-shrink-0">
                        <span class="bg-primary d-flex h-100 flex-column gap-1 p-1">
                          <span class="d-block p-1 px-2 bg-light-subtle rounded mb-2"></span>
                          <span class="d-block p-1 px-2 pb-0 bg-light-subtle"></span>
                          <span class="d-block p-1 px-2 pb-0 bg-light-subtle"></span>
                          <span class="d-block p-1 px-2 pb-0 bg-light-subtle"></span>
                        </span>
                      </span>
                      <span class="flex-grow-1">
                        <span class="d-flex h-100 flex-column">
                          <span class="bg-light d-block p-1"></span>
                          <span class="bg-light d-block p-1 mt-auto"></span>
                        </span>
                      </span>
                    </span>
                  </label>
                </div>
                <h5 class="fs-13 text-center mt-2">Dark</h5>
              </div>
              <div class="col-4">
                <button class="btn btn-link avatar-md w-100 p-0 overflow-hidden border collapsed" id="collapseBgGradient1" type="button" data-bs-toggle="collapse" data-bs-target="#collapseBgGradient" aria-expanded="false" aria-controls="collapseBgGradient" (click)="addActive('gradient')">
                  <span class="d-flex gap-1 h-100">
                    <span class="flex-shrink-0">
                      <span class="bg-vertical-gradient d-flex h-100 flex-column gap-1 p-1">
                        <span class="d-block p-1 px-2 bg-light-subtle rounded mb-2"></span>
                        <span class="d-block p-1 px-2 pb-0 bg-light-subtle"></span>
                        <span class="d-block p-1 px-2 pb-0 bg-light-subtle"></span>
                        <span class="d-block p-1 px-2 pb-0 bg-light-subtle"></span>
                      </span>
                    </span>
                    <span class="flex-grow-1">
                      <span class="d-flex h-100 flex-column">
                        <span class="bg-light d-block p-1"></span>
                        <span class="bg-light d-block p-1 mt-auto"></span>
                      </span>
                    </span>
                  </span>
                </button>
                <h5 class="fs-13 text-center mt-2">Gradient</h5>
              </div>
            </div>
            <div class="collapse" id="collapseBgGradient">
              <div class="d-flex gap-2 flex-wrap img-switch p-2 px-3 bg-light rounded">
                <div class="form-check sidebar-setting card-radio">
                  <input class="form-check-input" type="radio" name="data-sidebar" id="sidebar-color-gradient" value="gradient" [checked]="grd === 'gradient'" (change)="changeSidebarColor('gradient')" onchange="document.documentElement.setAttribute('data-sidebar', 'gradient')">
                  <label class="form-check-label p-0 avatar-xs rounded-circle" for="sidebar-color-gradient">
                    <span class="avatar-title rounded-circle bg-vertical-gradient"></span>
                  </label>
                </div>
                <div class="form-check sidebar-setting card-radio">
                  <input class="form-check-input" type="radio" name="data-sidebar" id="sidebar-color-gradient-2" value="gradient-2" [checked]="sidebar === 'gradient'" onchange="document.documentElement.setAttribute('data-sidebar', 'gradient-2')">
                  <label class="form-check-label p-0 avatar-xs rounded-circle" for="sidebar-color-gradient-2">
                    <span class="avatar-title rounded-circle bg-vertical-gradient-2"></span>
                  </label>
                </div>
                <div class="form-check sidebar-setting card-radio">
                  <input class="form-check-input" type="radio" name="data-sidebar" id="sidebar-color-gradient-3" value="gradient-3" [checked]="sidebar === 'gradient'" onchange="document.documentElement.setAttribute('data-sidebar', 'gradient-3')">
                  <label class="form-check-label p-0 avatar-xs rounded-circle" for="sidebar-color-gradient-3">
                    <span class="avatar-title rounded-circle bg-vertical-gradient-3"></span>
                  </label>
                </div>
                <div class="form-check sidebar-setting card-radio">
                  <input class="form-check-input" type="radio" name="data-sidebar" id="sidebar-color-gradient-4" value="gradient-4" [checked]="sidebar === 'gradient'" onchange="document.documentElement.setAttribute('data-sidebar', 'gradient-4')">
                  <label class="form-check-label p-0 avatar-xs rounded-circle" for="sidebar-color-gradient-4">
                    <span class="avatar-title rounded-circle bg-vertical-gradient-4"></span>
                  </label>
                </div>
              </div>
            </div>
            <div id="sidebar-img">
              <h6 class="mt-4 mb-0 fw-semibold text-uppercase">Sidebar Images</h6>
              <p class="text-muted">Choose a image of Sidebar.</p>
              <div class="d-flex gap-2 flex-wrap img-switch">
                <div class="form-check sidebar-setting card-radio">
                  <input class="form-check-input" type="radio" name="data-sidebar-image" id="sidebarimg-none" value="none" [checked]="sidebarImage === 'none'" (change)="changeSidebarImage('none')" onchange="document.documentElement.setAttribute('data-sidebar-image', 'none')">
                  <label class="form-check-label p-0 avatar-sm h-auto" for="sidebarimg-none">
                    <span class="avatar-md w-auto bg-light d-flex align-items-center justify-content-center">
                      <i class="ri-close-fill fs-20"></i>
                    </span>
                  </label>
                </div>
                <div class="form-check sidebar-setting card-radio">
                  <input class="form-check-input" type="radio" name="data-sidebar-image" id="sidebarimg-01" value="img-1" [checked]="sidebarImage === 'img-1'" (change)="changeSidebarImage('img-1')">
                  <label class="form-check-label p-0 avatar-sm h-auto" for="sidebarimg-01">
                    <img src="assets/images/sidebar/img-1.jpg" alt="" class="avatar-md w-auto object-fit-cover">
                  </label>
                </div>
                <div class="form-check sidebar-setting card-radio">
                  <input class="form-check-input" type="radio" name="data-sidebar-image" id="sidebarimg-02" value="img-2" [checked]="sidebarImage === 'img-2'" (change)="changeSidebarImage('img-2')">
                  <label class="form-check-label p-0 avatar-sm h-auto" for="sidebarimg-02">
                    <img src="assets/images/sidebar/img-2.jpg" alt="" class="avatar-md w-auto object-fit-cover">
                  </label>
                </div>
                <div class="form-check sidebar-setting card-radio">
                  <input class="form-check-input" type="radio" name="data-sidebar-image" id="sidebarimg-03" value="img-3" [checked]="sidebarImage === 'img-3'" (change)="changeSidebarImage('img-3')">
                  <label class="form-check-label p-0 avatar-sm h-auto" for="sidebarimg-03">
                    <img src="assets/images/sidebar/img-3.jpg" alt="" class="avatar-md w-auto object-fit-cover">
                  </label>
                </div>
                <div class="form-check sidebar-setting card-radio">
                  <input class="form-check-input" type="radio" name="data-sidebar-image" id="sidebarimg-04" value="img-4" [checked]="sidebarImage === 'img-4'" (change)="changeSidebarImage('img-4')">
                  <label class="form-check-label p-0 avatar-sm h-auto" for="sidebarimg-04">
                    <img src="assets/images/sidebar/img-4.jpg" alt="" class="avatar-md w-auto object-fit-cover">
                  </label>
                </div>
              </div>
            </div>
          </div>
        }

        <div id="sidebar-color">
          <h6 class="mt-4 mb-0 fw-semibold text-uppercase">Primary Color</h6>
          <p class="text-muted">Choose a color of Primary.</p>

          <div class="d-flex flex-wrap gap-2">
            <div class="form-check sidebar-setting card-radio">
              <input class="form-check-input" type="radio" name="data-theme-colors" id="themeColor-01" value="default" (change)="changeColor('default')">
              <label class="form-check-label avatar-xs p-0" for="themeColor-01"></label>
            </div>
            <div class="form-check sidebar-setting card-radio">
              <input class="form-check-input" type="radio" name="data-theme-colors" id="themeColor-02" value="green" (change)="changeColor('green')">
              <label class="form-check-label avatar-xs p-0" for="themeColor-02"></label>
            </div>
            <div class="form-check sidebar-setting card-radio">
              <input class="form-check-input" type="radio" name="data-theme-colors" id="themeColor-03" value="purple" (change)="changeColor('purple')">
              <label class="form-check-label avatar-xs p-0" for="themeColor-03"></label>
            </div>
            <div class="form-check sidebar-setting card-radio">
              <input class="form-check-input" type="radio" name="data-theme-colors" id="themeColor-04" value="blue" (change)="changeColor('blue')">
              <label class="form-check-label avatar-xs p-0" for="themeColor-04"></label>
            </div>
          </div>
        </div>

        <div id="preloader-menu">
          <h6 class="mt-4 mb-0 fw-semibold text-uppercase">Preloader</h6>
          <p class="text-muted">Choose a preloader.</p>

          <div class="row">
            <div class="col-4">
              <div class="form-check sidebar-setting card-radio">
                <input class="form-check-input" type="radio" name="data-preloader" id="preloader-view-custom" value="enable" [checked]="preLoader === 'enable'" (change)="changeLoader('enable')">
                <label class="form-check-label p-0 avatar-md w-100 material-shadow" for="preloader-view-custom">
                  <span class="d-flex gap-1 h-100">
                    <span class="flex-shrink-0">
                      <span class="bg-light d-flex h-100 flex-column gap-1 p-1">
                        <span class="d-block p-1 px-2 bg-primary-subtle rounded mb-2"></span>
                        <span class="d-block p-1 px-2 pb-0 bg-primary-subtle"></span>
                        <span class="d-block p-1 px-2 pb-0 bg-primary-subtle"></span>
                        <span class="d-block p-1 px-2 pb-0 bg-primary-subtle"></span>
                      </span>
                    </span>
                    <span class="flex-grow-1">
                      <span class="d-flex h-100 flex-column">
                        <span class="bg-light d-block p-1"></span>
                        <span class="bg-light d-block p-1 mt-auto"></span>
                      </span>
                    </span>
                  </span>
                  <!-- <div id="preloader"> -->
                  <div id="status" class="d-flex align-items-center justify-content-center">
                    <div class="spinner-border text-primary avatar-xxs m-auto" role="status">
                      <span class="visually-hidden">Loading...</span>
                    </div>
                  </div>
                <!-- </div> -->
              </label>
            </div>
            <h5 class="fs-13 text-center mt-2">Enable</h5>
          </div>
          <div class="col-4">
            <div class="form-check sidebar-setting card-radio">
              <input class="form-check-input" type="radio" name="data-preloader" id="preloader-view-none" value="disable" [checked]="preLoader === 'disable'" (change)="changeLoader('disable')">
              <label class="form-check-label p-0 avatar-md w-100 material-shadow" for="preloader-view-none">
                <span class="d-flex gap-1 h-100">
                  <span class="flex-shrink-0">
                    <span class="bg-light d-flex h-100 flex-column gap-1 p-1">
                      <span class="d-block p-1 px-2 bg-primary-subtle rounded mb-2"></span>
                      <span class="d-block p-1 px-2 pb-0 bg-primary-subtle"></span>
                      <span class="d-block p-1 px-2 pb-0 bg-primary-subtle"></span>
                      <span class="d-block p-1 px-2 pb-0 bg-primary-subtle"></span>
                    </span>
                  </span>
                  <span class="flex-grow-1">
                    <span class="d-flex h-100 flex-column">
                      <span class="bg-light d-block p-1"></span>
                      <span class="bg-light d-block p-1 mt-auto"></span>
                    </span>
                  </span>
                </span>
              </label>
            </div>
            <h5 class="fs-13 text-center mt-2">Disable</h5>
          </div>
        </div>

      </div>
      <!-- end preloader-menu -->
      @if( theme == 'galaxy'){
        <div id="body-img">
          <h6 class="mt-4 mb-0 fw-semibold text-uppercase">Background Image</h6>
          <p class="text-muted">Choose a body background image.</p>

          <div class="row">
            <div class="col-4">
              <div class="form-check sidebar-setting card-radio">
                <input class="form-check-input" type="radio" name="data-body-image" id="body-img-none" value="none" (change)="changeBackgroundImage('none')">
                <label class="form-check-label p-0 avatar-md w-100" data-body-image="none" for="body-img-none">
                  <span class="d-flex gap-1 h-100">
                    <span class="flex-shrink-0">
                      <span class="bg-light d-flex h-100 flex-column gap-1 p-1">
                        <span class="d-block p-1 px-2 bg-primary-subtle rounded mb-2"></span>
                        <span class="d-block p-1 px-2 pb-0 bg-primary-subtle"></span>
                        <span class="d-block p-1 px-2 pb-0 bg-primary-subtle"></span>
                        <span class="d-block p-1 px-2 pb-0 bg-primary-subtle"></span>
                      </span>
                    </span>
                    <span class="flex-grow-1">
                      <span class="d-flex h-100 flex-column">
                        <span class="bg-light d-block p-1"></span>
                        <span class="bg-light d-block p-1 mt-auto"></span>
                      </span>
                    </span>
                  </span>
                </label>
              </div>
              <h5 class="fs-13 text-center mt-2">None</h5>
            </div>
            <!-- end col -->
            <div class="col-4">
              <div class="form-check sidebar-setting card-radio">
                <input class="form-check-input" type="radio" name="data-body-image" id="body-img-one" value="img-1" (change)="changeBackgroundImage('img-1')">
                <label class="form-check-label p-0 avatar-md w-100" data-body-image="img-1" for="body-img-one">
                </label>
              </div>
              <h5 class="fs-13 text-center mt-2">One</h5>
            </div>
            <!-- end col -->

            <div class="col-4">
              <div class="form-check sidebar-setting card-radio">
                <input class="form-check-input" type="radio" name="data-body-image" id="body-img-two" value="img-2" (change)="changeBackgroundImage('img-2')">
                <label class="form-check-label p-0 avatar-md w-100" data-body-image="img-2" for="body-img-two">
                </label>
              </div>
              <h5 class="fs-13 text-center mt-2">Two</h5>
            </div>
            <!-- end col -->

            <div class="col-4">
              <div class="form-check sidebar-setting card-radio">
                <input class="form-check-input" type="radio" name="data-body-image" id="body-img-three" value="img-3" (change)="changeBackgroundImage('img-3')">
                <label class="form-check-label p-0 avatar-md w-100" data-body-image="img-3" for="body-img-three">
                </label>
              </div>
              <h5 class="fs-13 text-center mt-2">Three</h5>
            </div>
            <!-- end col -->
          </div>
          <!-- end row -->
        </div>
      }
    </div>
  </ngx-simplebar>
</div>
</ng-template>